"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Row = /*#__PURE__*/function (_React$Component) {
  _inherits(Row, _React$Component);

  var _super = _createSuper(Row);

  function Row(props) {
    var _this;

    _classCallCheck(this, Row);

    _this = _super.call(this, props);
    _this.state = {
      shown: false
    };
    return _this;
  }

  _createClass(Row, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var loadDelay = 100 + 50 * (this.props.i % this.props.pageSize);
      this.timeout = setTimeout(function () {
        return _this2.setState({
          shown: true
        });
      }, loadDelay);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          current = _this$props.current,
          children = _this$props.children,
          actionType = _this$props.actionType,
          header = _this$props.header,
          rowHeight = _this$props.rowHeight,
          data = _this$props.data,
          printView = _this$props.printView,
          length = _this$props.length,
          sortFilters = _this$props.sortFilters,
          _onClick = _this$props.onClick,
          headerTexts = _this$props.headerTexts,
          hasRanking = _this$props.hasRanking,
          minMaxRankingMap = _this$props.minMaxRankingMap,
          allowMultiline = _this$props.allowMultiline,
          hasSideBar = _this$props.hasSideBar;
      return /*#__PURE__*/_react["default"].createElement(_styled.StyledRow, {
        current: current,
        height: rowHeight,
        allowMultiline: allowMultiline,
        header: header,
        onClick: function onClick() {
          return _onClick && !header && _onClick(data);
        },
        hasClick: !!_onClick,
        printView: printView,
        hasSideBar: hasSideBar
      }, _react["default"].Children.map(children, function (child) {
        var childProps = {
          header: !!header
        };
        var cellData = child.props.data;
        var _child$props = child.props,
            type = _child$props.type,
            headerText = _child$props.headerText;
        var rank = null; // CellSorter components are connected, so the direct child will be the redux connected instance -
        // we need to go deeper to get the actual type

        if (child.type.WrappedComponent) {
          var _child$props$children = child.props.children.props;
          type = _child$props$children.type;
          headerText = _child$props$children.headerText;
          cellData = _child$props$children.data;
          Object.assign(childProps, {
            actionType: actionType,
            sortFilters: sortFilters,
            sortBy: type
          });
        }

        if (hasRanking && data && typeof data["rank_".concat(type)] === 'number') {
          rank = {
            current: data["rank_".concat(type)],
            total: length,
            maxRankNumerator: minMaxRankingMap["rank_".concat(type)] ? minMaxRankingMap["rank_".concat(type)].max : null,
            minRankNumerator: minMaxRankingMap["rank_".concat(type)] ? minMaxRankingMap["rank_".concat(type)].min : null
          };
        }

        Object.assign(childProps, {
          headerText: headerText || headerTexts[type],
          type: type,
          // the type is what gets added as a class - this will need a refactor down the line
          data: cellData || data[type],
          rank: rank,
          printView: printView
        });
        return _react["default"].cloneElement(child, childProps);
      }));
    }
  }]);

  return Row;
}(_react["default"].Component);

exports["default"] = Row;
Row.defaultProps = {
  data: {},
  headerTexts: {}
};

//# sourceMappingURL=Row.js.map